import React, { useState, useEffect, useCallback, useRef } from 'react';
import { DataGrid, GridToolbarContainer, GridToolbar } from '@mui/x-data-grid';
import { fetchConToken } from 'helpers/fetch';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Swal from 'sweetalert2';
import { useGlobalState } from 'resources/GlobalStateContext';
import { getDataSession, setDataSession } from 'views/Utils/Common';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CachedIcon from '@mui/icons-material/Cached';
import FilledInput from '@mui/material/FilledInput';
import Tooltip from '@mui/material/Tooltip';
import InputAdornment from '@mui/material/InputAdornment';

const ListTable = (props) => {
  const { setModelPaginate, setBuscar, url, hideSearch } = props;
  const theme = createTheme({ palette: { primary: { main: '#1976d2' } } });
  const [buscar, setBuscarInterno] = useState('');
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(true);
  const [modelPaginate, setModelPaginateInterno] = useState({ page: 0, pageSize: 10 });
  const [, setSelectionModel] = useState([]);
  const { globalVariable, } = useGlobalState();
  const [sucursalId, setSucursalId] = useState(getDataSession('sucursal'));
  const [selectedCellData, setSelectedCellData] = useState(null);
  const [selectedTitleCellData, setSelectedTitleCellData] = useState(null);
  const [keyDownEnter, setKeyDownEnter] = useState();
  const buscarRef = useRef(buscar);

  const handlePageSizeChange = (newPageSize) => {
    setModelPaginateInterno(newPageSize);
    //fetchData(newPageSize.page, newPageSize.pageSize);
  };

  const handleSelectionChange = (newSelection) => {
    setSelectionModel(newSelection);
    if (props.onChangeSelectdIds) props.onChangeSelectdIds(newSelection);
  };

  function handleInputChange(event) {
    const { value } = event.target;
    setBuscarInterno(value);
  };

  const CustomToolbar = () => (<GridToolbarContainer>
    <GridToolbar></GridToolbar>
  </GridToolbarContainer>);

  const DialogContentData = (TitleCellData, CellData) => {
    if (TitleCellData?.toUpperCase() === 'QR') return (<img src={"data:image/jpg;base64," + CellData} style={{ maxWidth: "95%" }} alt='codigo QR' />);

    ///if ((TitleCellData ?? "").toUpperCase().includes("FECHA"))
    ///  return (<TextField fullWidth sx={{ m: 1, minWidth: 120 }} size="small" type="date" label={TitleCellData} value={CellData} InputLabelProps={{ shrink: true, }} />);

    return CellData;
  }

  const fetchData = useCallback((page, pageSize) => {
    setLoading(true)
    try {
      if (setModelPaginate) setModelPaginate({ page: page, pageSize: pageSize });

      if (setBuscar) setBuscar(buscarRef.current);

      fetchConToken(url + `&paginas=${page}&totalXpagina=${pageSize}${(!hideSearch ? `&busqueda=${buscarRef.current}` : '')}`).then(response => {
        if (response.hasOwnProperty('status')) {
          Object.entries(response?.errors).forEach(([, value]) => {
            Swal.fire('Error', value[0], 'error');
            setLoading(false);
          });
          return false;
        } else if (response.hasOwnProperty('codigo')) {
          Swal.fire('Error', response.mensajes[0], 'error');
          setLoading(false);
          return;
        }

        setRows([]);
        setRows(response.data);
        setTotalRows(response.recordsFiltered);
        setLoading(false);
      });
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }, [setModelPaginate, setBuscar, url, hideSearch]);

  useEffect(() => {
    //console.log("efect 3");
    if (setBuscar) setBuscar(buscarRef.current);

    fetchData(modelPaginate.page, modelPaginate.pageSize);
  }, [keyDownEnter, setBuscar, fetchData, modelPaginate.page, modelPaginate.pageSize]);//}, [buscar, props.url, props.path]);

  useEffect(() => {
    if (props.reload === true) {
      fetchData(0, modelPaginate.pageSize);
    }
  }, [props.reload, fetchData, modelPaginate.pageSize]);

  useEffect(() => { if (buscarRef) buscarRef.current = buscar; }, [buscar]);

  function handleChange(e) {
    setSucursalId(e.target.value);
    setDataSession('sucursal', e.target.value);
    fetchConToken(`ConfiguracionesSucursales/ConfiguracionSincronizacion?sucursal_id=${e.target.value}`).then(response => {
      setDataSession('confSincro', '');
      if (response.hasOwnProperty('status') && response.status === 400) {
        Object.entries(response.errors).forEach(([, value]) => Swal.fire('Error', value[0], 'error'));
        return;
      } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
        Swal.fire('Error', response.mensajes[0], 'error');
        return;
      }

      setDataSession('confSincro', JSON.stringify(response));
    });
    fetchConToken(`ConfiguracionesSucursales?nombre=TIENDA&sucursal_id=${e.target.value}`).then(response => {
      setDataSession('tienda', response.valor);
      window.location.reload()
    });
  }

  const convertirMayuscula = (cadena) => {
    return cadena.split(' ').map((palabra) => {
      return palabra.charAt(0).toUpperCase() + palabra.slice(1);
    }).join(' ');
  };

  const handleCellClick = (params) => {
    setSelectedTitleCellData(convertirMayuscula(params.field.replace("_", " ").replace(".", " ")));
    if (params.field === 'documento_FoliosOrigen') {
      setSelectedCellData(RenderDandleCellClickFoliosOrigen(params.row));
      return;
    }

    var columns = params.field.split(".");
    if (columns.length === 1) setSelectedCellData(params.row[params.field]);

    if (columns.length === 2) setSelectedCellData(params.row[columns[0]][columns[1]]);
  };

  const RenderDandleCellClickFoliosOrigen = (row) => {
    if (row.idVentaCopia > 0) return `${row.folioVentaCopia}, ${row.documento_FoliosOrigen.map(objeto => objeto.erp_Folio)?.join(', ')}`;

    return row.documento_FoliosOrigen.map(objeto => objeto.erp_Folio)?.join(', ');
  }

  const handleCloseDialog = () => {
    setSelectedTitleCellData(null);
    setSelectedCellData(null);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') setKeyDownEnter(!keyDownEnter);
  }

  return (<Box sx={{ position: "relative" }}>
    {!props.hideSearch ? (<div className='row' style={{ paddingBottom: "10px", paddingTop: "15px" }}>
      <div className='col-md-4'>
        {!props.hideConexion && <FormControl fullWidth sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel id="sucursal-checkbox-label">Conexión</InputLabel>
          <Select onChange={handleChange} value={sucursalId} label="Conexión">
            {globalVariable?.map((item) => {
              return <MenuItem key={item.id} value={item.id}>
                <ListItemText primary={item.nombre + (item.principal ? " (Principal)" : "")} />
              </MenuItem>
            })}
          </Select>
        </FormControl>}
      </div>
      <div className='col-md-2'>{props.hideFiltroExtra ? props.filtroExtra : ''}</div>
      <div className='col-md-6'>
        <FormControl className='form-control'>
          <InputLabel>Buscar</InputLabel>
          <FilledInput fullWidth sx={{ m: 1, minWidth: 120 }} size="small" label="Buscar" value={buscar} type="search" variant="filled" onChange={handleInputChange} onKeyDown={onKeyDown}
            endAdornment={
              <InputAdornment position="end">
                <Tooltip title={buscar ? "Buscar" : "Actualizar"}>
                  <IconButton onClick={() => setKeyDownEnter(!keyDownEnter)}>{buscar ? <SearchIcon /> : <CachedIcon />}</IconButton>
                </Tooltip>
              </InputAdornment>
            }
          />
        </FormControl>
      </div>
    </div>) : !props.hideConexion && (<div className='row' style={{ paddingBottom: "10px", paddingTop: "15px" }}>
      <div className='col-md-4 row'>
        <div className='col-md-10'>
          <FormControl fullWidth sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="sucursal-checkbox-label">Conexión</InputLabel>
            <Select onChange={handleChange} value={sucursalId} label="Conexión">
              {globalVariable?.map((item) => {
                return <MenuItem key={item.id} value={item.id}>
                  <ListItemText primary={item.nombre + (item.principal ? " (Principal)" : "")} />
                </MenuItem>
              })}
            </Select>
          </FormControl>
        </div>
        <div className='col-md-2 row'>
          <Tooltip title={buscar ? "Buscar" : "Actualizar"}>
            <IconButton onClick={() => setKeyDownEnter(!keyDownEnter)} size="large">{buscar ? <SearchIcon fontSize="large" /> : <CachedIcon fontSize="large" />}</IconButton>
          </Tooltip>
        </div>
      </div>
      <div className='col-md-2'>{props.hideFiltroExtra ? props.filtroExtra : ''}</div>
      <div className='col-md-6' />
    </div>)}
    <ThemeProvider theme={theme}>
      <Box sx={{ width: "100%", overflowX: 'auto', position: "absolute" }}>
        <DataGrid
          columns={props.columns}
          //maxColumns={2}
          rows={rows}
          paginationMode="server"
          paginationModel={modelPaginate}
          rowCount={totalRows}
          loading={loading}
          autoHeight={true}
          pageSizeOptions={[5, 10, 25, 50, 100]}
          checkboxSelection={props.checkboxSelection}
          components={{ Toolbar: CustomToolbar, }}
          disableColumnFilter
          onPaginationModelChange={handlePageSizeChange}
          onRowSelectionModelChange={handleSelectionChange}
          ///disableRowSelectionOnClick
          ///onEditCellChange={props.onEditCellChange}
          ///editMode="cell"
          ///isTreeData={props.isTreeData}
          onCellDoubleClick={handleCellClick}
        />
        <Dialog open={!!selectedCellData} onClose={handleCloseDialog}>
          <DialogTitle>{selectedTitleCellData}</DialogTitle>
          <DialogContent>{DialogContentData(selectedTitleCellData, selectedCellData)}</DialogContent>
        </Dialog>
      </Box>
    </ThemeProvider>
  </Box>);
}

export default ListTable;